import { css, jsx} from '@emotion/react'
import { ButtonBase } from '@mui/material';
 /** @jsxImportSource @emotion/react */
import React, { useContext, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Space, Table} from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import { useEffect } from 'react';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useNavigate } from 'react-router-dom';

import axios from '../apiClient';
import Alert from '../alert'
import { pageContext } from '../../context';



export default function List() {
  const {currentPages,changePages} = useContext(pageContext)
  const [masters,setMasters] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [totalMasters, setTotalMasters] = useState();
  const [searchName,setSearchName] = useState('');
  const mounted = useRef(false)

  const navigate = useNavigate()
  const [page,setPage] = useState(currentPages.masterManagementListPage);
  const columns = [
    {
      title: 'Username',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Phone No.',
      key: 'phone_number',
      dataIndex: 'phone_number',
    },
    {
      title: 'Units',
      key: 'amount',
      dataIndex: 'amount',
      render : (amount) => amount.toLocaleString()
    },
    {
      title: 'Commission',
      key: 'commission',
      dataIndex: 'commission',
      render: (amount) => Number(amount).toLocaleString()
    },
    {
      title: 'Action',
      fixed: 'right',
      // width: "610px",
      // title: <div style={{ textAlign: 'center' }}>Action</div>,
      render: (data) => {
        const {id,is_suspended} = data;
        const negativeColor = "#EA5455"
        const closeColor = `${is_suspended == 'true' ? `${negativeColor}`: `#0E8388`}`
        const editColor = "#4E6E81"
        const commissionsColor = 'green';
        const statementColor = 'orange';
        const debtColor = 'red';
        return (
        <Space size="middle">
          <Button onClick={()=>handleAction({action: "lock",status: `${is_suspended == `true` ? false : true}`,id})} css={css`color: black;border-color: ${closeColor};:hover{border-color: ${closeColor};};`} color='success' variant="outlined" startIcon={is_suspended == 'true' ? <LockOpenRoundedIcon css={css`color: ${closeColor};`}/> : <LockRoundedIcon css={css`color: ${closeColor};`}/>}>
            {is_suspended == 'true' ? `UnLock` : `Lock`}
         </Button>
         <Button onClick={()=>handleAction({action: "edit",data})}  css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};};`} color='success' variant="outlined" startIcon={<EditRoundedIcon css={css`color: ${editColor};`}/>}>
            Edit
         </Button>
         <Button onClick={()=>handleAction({action: "commissions",data})} css={css`color: black;border-color: ${commissionsColor};:hover{border-color: ${commissionsColor};}`} color='success' variant="outlined" startIcon={<SummarizeRoundedIcon css={css`color: ${commissionsColor};`}/>}>
            Commissions
         </Button>
         <Button onClick={()=>handleAction({action: "statements",data})} css={css`color: black;border-color: ${statementColor};:hover{border-color: ${statementColor};}`} color='success' variant="outlined" startIcon={<SummarizeRoundedIcon css={css`color: ${statementColor};`}/>}>
            Statements
         </Button>
         <Button onClick={()=>handleAction({action: "debts",data})} css={css`color: black;border-color: ${debtColor};:hover{border-color: ${debtColor};}`} color='success' variant="outlined" startIcon={<SummarizeRoundedIcon css={css`color: ${debtColor};`}/>}>
            Debts
         </Button>
        </Space>
      )},
    },
  ];
  const handleAction = (obj) =>{
    const {action} = obj;
    if(action == "commissions"){
      navigate('/master-management/masterCommissions',{state: obj.data})
      return
    }
    if(action == "statements"){
      navigate('/master-management/statements',{state: obj.data})
      return
    }
    if(action == "debts"){
      navigate('/master-management/debtList',{state: obj.data})
      return
    }
    if(action == "edit"){
      navigate('/master-management/list/editUser',{state: obj.data})
      return
    }
    fetchData(obj)
   
  }
  // get data from backend when componenet is first mounted

  async function fetchData({action,status,id}) {
    setLoading(true)
    const token = localStorage.getItem("token");
    const auth = {
        headers: { Authorization: `Bearer ${token}` }
    };
    // if action is true -----------------------------------------
    if(action){
      let data;
      let url;
      let params;
      if(action == 'lock'){
        params ={'masterId': id,"is_suspended": status}
        url = `/master/updateSuspendedStatus`
      }
      data = await axios.put(url,params)

      if(data.code == 200){
        if(action == 'lock') data.message = `${status == 'true' ? "Successfully locked the master" : "Successfully unlocked the master"}`
      }
      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
    }
    //-------------------------------------------------------------------------------------
    let data = await axios.get(`/master/getMasterByParentId?current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setMasters([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setMasters(data.data.masters)
    setTotalMasters(data.data.pagination.total)
    setLoading(false)
}
  //--------------------------------------------------
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  
  useEffect(()=>{
    if(mounted.current){
      if(searchName != ''){
        handleSearch(searchName,page)
        return;
      }
      fetchData({})
    }
  },[page])

  useEffect(()=>{
    if(mounted.current) setPage(1)
  },[searchName])

  useEffect(()=>{
    mounted.current = true
    fetchData({})
  },[])
  const handleSearch = async (name,page) =>{
    setLoading(true)
    setSearchName(name)
    let data = await axios.get(`/master/getMasterByParentId?s=${name}&current=${page}&pageSize=10`)
    setLoading(false)
    if (data.code != 200) {
        if(data.code == 404){
            setMasters([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        return
    }
    setMasters(data.data.masters)
    setTotalMasters(data.data.pagination.total)
    }
  const handlePageChange = (page) => {
    setPage(page)
    changePages({masterManagementListPage: page})
  }
  return (
    <div>
      <div>
        <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
        <div css={css`display: flex;justify-content: space-between;`}>
          <input placeholder='Search...' css={css`padding: 0.6rem 0.6rem;border-radius: 0.6rem;border: 1px solid grey;outline: none;&:focus {border-color: #5e35b1;}`} onChange={(e)=>handleSearch(e.currentTarget.value,page)}/>
          <ButtonBase onClick={()=>navigate('/master-management/createUser')} component="div" css={css`background-color: #5e35b1;padding: 0 1rem;border-radius: 0.6rem;color: white;`}><AddIcon css={css`font-size: 1rem;`}/>Add New Master</ButtonBase>
        </div>
        <div>
          <Table loading={loading} scroll={{x: 'max-content'}} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={masters} />
          <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalMasters} pageSize={10} showSizeChanger={false} onChange={(page)=> handlePageChange(page)}/>
        </div>
      </div>
    </div>
  )
}
